import time from 'utils/time';

const calculateDifferenceBetweenDays = (date) => {
  const today = time().startOf('day');
  const target = time(time.getCalendarDateKey(date)).startOf('day');
  return target.diff(today, 'day');
};

export default calculateDifferenceBetweenDays;
